import { useEffect, useRef, useState } from "react";

/**
 * Password input with delayed masking.
 * After each keystroke the input is rendered as type="text" for ~700ms so the
 * user can verify what they typed; it then reverts to type="password".
 * The actual character handling stays native — no value reconstruction
 * so cursor / paste / IME behaviour remains correct.
 */
export default function DelayedPasswordInput({ onChange, revealMs = 700, ...rest }) {
  const [reveal, setReveal] = useState(false);
  const timerRef = useRef(null);

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    []
  );

  const handleChange = (e) => {
    setReveal(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setReveal(false), revealMs);
    onChange?.(e);
  };

  return (
    <input
      {...rest}
      type={reveal ? "text" : "password"}
      onChange={handleChange}
      autoComplete={rest.autoComplete || "current-password"}
    />
  );
}
